/**
 * Tag the first rendered page group of each OCR result.
 *
 * A result contributes one page group per page its chunks landed on, so a
 * per-result affordance (the QA accept/reject buttons) must render on exactly
 * one of them. "The group whose `pageIndexInResult` is 1" is NOT that group: a
 * template-pool run splits a container across several results, and a result
 * whose chunks start on page 2 has no index-1 group at all — its buttons never
 * rendered, leaving the result stuck in its QA tier with no way to act on it.
 *
 * Position in the passed array decides, so callers must tag AFTER sorting and
 * filtering — otherwise the flag can land on a group that never renders.
 */
export function withFirstGroupPerResult<T extends { result: { id: number } }>(
  groups: T[]
): (T & { isFirstGroupForResult: boolean })[] {
  const seen = new Set<number>();

  return groups.map((group) => {
    const isFirstGroupForResult = !seen.has(group.result.id);
    seen.add(group.result.id);
    return { ...group, isFirstGroupForResult };
  });
}
